import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userList: {
        data: [],
        loading: false,
        error: null,
        page: 1,
        limit: 1,
        total: 0,
        totalPages: 1,
    },
    userProfile: { data: {}, loading: false, error: null },
    createUser: { loading: false, error: null },
    updateUser: { loading: false, error: null },
    submitAnswers: { loading: false, error: null },
    userAnswers: { data: [], loading: false, error: null },
    userProgress: { data: [], loading: false, error: null },
    userResults: { data: {}, loading: false, error: null },
    deletedUsersList: {
        data: [],
        loading: false,
        error: null,
        page: 1,
        limit: 1,
        total: 0,
        totalPages: 1,
    },
}
const userSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        fetchUsersStart: (state, action) => {
            state.userList.loading = true;
            state.userList.error = null;
            if (action.payload.page === 1) {
                state.userList.data = [];
            }
        },
        fetchUsersSuccess: (state, action) => {
            state.userList = { ...action.payload, loading: false };
        },
        fetchUsersFail: (state, action) => {
            state.userList.loading = false;
            state.userList.error = action.payload;
        },

        fetchUserProfileStart: (state) => {
            state.userProfile.loading = true;
            state.userProfile.error = null;
        },
        fetchUserProfileSuccess: (state, action) => {
            state.userProfile.loading = false;
            state.userProfile.data = action.payload;
        },
        fetchUserProfileFail: (state, action) => {
            state.userProfile.loading = false;
            state.userProfile.error = action.payload;
        },

        createUserStart: (state) => {
            state.createUser.loading = true;
            state.createUser.error = null;
        },
        createUserSuccess: (state) => {
            state.createUser.loading = false;
        },
        createUserFail: (state, action) => {
            state.createUser.loading = false;
            state.createUser.error = action.payload;
        },

        updateUserStart: (state) => {
            state.updateUser.loading = true;
            state.updateUser.error = null;
        },
        updateUserSuccess: (state) => {
            state.updateUser.loading = false;
        },
        updateUserFail: (state, action) => {
            state.updateUser.loading = false;
            state.updateUser.error = action.payload;
        },

        submitAnswersStart: (state) => {
            state.submitAnswers.loading = true;
            state.submitAnswers.error = null;
        },
        submitAnswersSuccess: (state) => {
            state.submitAnswers.loading = false;
        },
        submitAnswersFail: (state, action) => {
            state.submitAnswers.loading = false;
            state.submitAnswers.error = action.payload;
        },

        fetchUserAnswersStart: (state) => {
            state.userAnswers.loading = true;
            state.userAnswers.error = null;
        },
        fetchUserAnswersSuccess: (state, action) => {
            state.userAnswers.loading = false;
            state.userAnswers.data = action.payload;
        },
        fetchUserAnswersFail: (state, action) => {
            state.userAnswers.loading = false;
            state.userAnswers.error = action.payload;
        },

        fetchUserProgressStart: (state) => {
            state.userProgress.loading = true;
            state.userProgress.error = null;
        },
        fetchUserProgressSuccess: (state, action) => {
            state.userProgress.loading = false;
            state.userProgress.data = action.payload;
        },
        fetchUserProgressFail: (state, action) => {
            state.userProgress.loading = false;
            state.userProgress.error = action.payload;
        },

        fetchUserResultsStart: (state) => {
            state.userResults.loading = true;
            state.userResults.error = null;
        },
        fetchUserResultsSuccess: (state, action) => {
            state.userResults.loading = false;
            state.userResults.data = action.payload;
        },
        fetchUserResultsFail: (state, action) => {
            state.userResults.loading = false;
            state.userResults.error = action.payload;
        },

        fetchDeletedUsersStart: (state, action) => {
            state.deletedUsersList.loading = true;
            state.deletedUsersList.error = null;
            if (action.payload?.page === 1) {
                state.deletedUsersList.data = [];
            }
        },
        fetchDeletedUsersSuccess: (state, action) => {
            state.deletedUsersList = { ...action.payload, loading: false };
        },
        fetchDeletedUsersFail: (state, action) => {
            state.deletedUsersList.loading = false;
            state.deletedUsersList.error = action.payload;
        },
    },
});

export const {
    fetchUsersStart,
    fetchUsersSuccess,
    fetchUsersFail,
    fetchUserProfileStart,
    fetchUserProfileSuccess,
    fetchUserProfileFail,
    createUserStart,
    createUserSuccess,
    createUserFail,
    updateUserStart,
    updateUserSuccess,
    updateUserFail,
    submitAnswersStart,
    submitAnswersSuccess,
    submitAnswersFail,
    fetchUserAnswersStart,
    fetchUserAnswersSuccess,
    fetchUserAnswersFail,
    fetchUserProgressStart,
    fetchUserProgressSuccess,
    fetchUserProgressFail,
    fetchUserResultsStart,
    fetchUserResultsSuccess,
    fetchUserResultsFail,
    fetchDeletedUsersStart,
    fetchDeletedUsersSuccess,
    fetchDeletedUsersFail,
} = userSlice.actions;

export default userSlice.reducer;